export const ACCOUNT_USERS_RESET_STATE = 'ACCOUNT_USERS_RESET_STATE';
export const ACCOUNT_USERS_CURRENT_ITEM = 'ACCOUNT_USERS_CURRENT_ITEM';

export const ACCOUNT_USERS_REQUEST_LOADING = 'ACCOUNT_USERS_REQUEST_LOADING';
export const ACCOUNT_USERS_REQUEST_SUCCESS = 'ACCOUNT_USERS_REQUEST_SUCCESS';
export const ACCOUNT_USERS_REQUEST_FAILED = 'ACCOUNT_USERS_REQUEST_FAILED';

export const ACCOUNT_USERS_CURRENT_ACTION = 'ACCOUNT_USERS_CURRENT_ACTION';
export const ACCOUNT_USERS_RESET_ACTION = 'ACCOUNT_USERS_RESET_ACTION';